export function delegatify(originalMethod, keyResolver) {
    const delegatedKeysMap = new Map();
    const keyGenerator = keyResolver !== null && keyResolver !== void 0 ? keyResolver : ((...args) => JSON.stringify(args));
    return function (...args) {
        const key = keyGenerator(...args);
        if (!delegatedKeysMap.has(key)) {
            delegatedKeysMap.set(key, originalMethod.apply(this, args).finally(() => delegatedKeysMap.delete(key)));
        }
        return delegatedKeysMap.get(key);
    };
}
